var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-title"},[(!_vm.isHomePage)?_c('a',{on:{"click":_vm.goHome}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e(),_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":"img/logo.png","title":"自助制图系统"}})]),_c('span',{staticClass:"app-name",on:{"click":_vm.redirectToHome}},[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }